module.exports = __webpack_public_path__ + "src/resources/excel.png";